import ProductAd from './ProductAd.vue'

export { ADS, AD_DISPLAYS } from './ProductAd.vue'

export default ProductAd
